import React from "react";
import "./Payout.scss"; // Make sure to import your CSS file
import commObj from "../../../constants/Common";
import { getSession } from "../../../redux/actions/authActions";
import { OverlayTrigger, Tooltip, Form } from "react-bootstrap";
import { Icon } from "@iconify/react";
import { Formik } from "formik";
import { CustomCard } from "../../CustomCard";

export const PayoutFilesCard = ({ data, handleUploadShow }) => {
  const { svcf_id, svcf_filename, svcpol_batch_num, sys_crte_tsp } = data;

  // const { refsdata } = useSelector((state) => state.refstypes);
  // const [showMore, setShowMore] = useState(false);
  const { role_id } = getSession(); // Get the role ID from session storage
  // const history = useHistory(); // Initialize useHistory hook

  //const xchange_rate = refsdata.usr?.iso_currency_xchng || [];
  const sys_crte_tspf = commObj.convertUTCToLocalTime(sys_crte_tsp);
  return (
    <Formik initialValues={{}} onSubmit={(values) => {}}>
      {({ handleSubmit }) => (
        <Form onSubmit={handleSubmit}>
          <CustomCard className="">
            <div
              className="d-flex justify-content-between align-items-center !pb-3 !mb-4"
              style={{ borderBottom: "1px solid #E7E7E9" }}
            >
              <div className="d-flex align-items-center justify-content-center gap-2">
                <div className="icons-container">
                  <div className="icons mb-0">
                    {role_id < 5 && (
                      <OverlayTrigger
                        placement="top"
                        overlay={
                          <Tooltip id="tooltip-top">Upload to AWS S3</Tooltip>
                        }
                      >
                        <span
                          onClick={() =>
                            handleUploadShow(svcf_id, svcf_filename)
                          }
                        >
                          <Icon icon="logos:aws-glacier" />
                        </span>
                      </OverlayTrigger>
                    )}
                  </div>
                </div>
                <div>
                  <h6 className="card-title mb-0">{svcpol_batch_num}</h6>
                  <small>Batch#:{svcf_id}</small>
                </div>
              </div>
            </div>
            <div className="row gap-y-[18px]">
              <div className="col-12">
                <small>File Name:</small>
                <p className="mb-0">{svcf_filename}</p>
              </div>
              <div className="col-12">
                <small>Generated on:</small>
                <p className="mb-0">{sys_crte_tspf}</p>
              </div>
            </div>
          </CustomCard>
        </Form>
      )}
    </Formik>
  );
};
